//bao migrate skip
import * as ko from "knockout";
import Bao from "./../../services/bao-service";
import BaoDialog from "./../../factories/bao-dialog";

class PurchaseVendorArtikelTabDialog {
    Bao = Bao;
    Dialog: BaoDialog;
    PurchaseVendorArticleTypeId = ko.observable<string>();
    PurchaseVendorArticleTypeName = ko.observable();
    ConfigurationItemTypeId = ko.observable<string>();
    ConfigurationItemTypeName = ko.observable();
    ManufacturerId = ko.observable<string>();
    ManufacturerName = ko.observable();
    ManufacturerTypeId = ko.observable<string>();
    ManufacturerTypeName = ko.observable();
    SoftwareId = ko.observable<string>();
    SoftwareName = ko.observable();
    WarrantyTypeId = ko.observable<string>();
    WarrantyTypeName = ko.observable();
    Name1 = ko.observable();
    Name2 = ko.observable();
    Price = ko.observable();
    Number = ko.observable();
    IsDisabled = ko.observable();
    ManufacturerEnabledBinding = ko.observable<boolean>(false);
    ManufacturerTypeEnabledBinding = ko.observable<boolean>(false);
    constructor(data: any, dialog: BaoDialog) {
        this.Dialog = dialog;
        $.extend(this, data);
        this.ConfigurationItemTypeId.subscribe((value) => {
            if (value != null) {
                this.ManufacturerEnabledBinding(true);
                //this.ManufacturerTypeEnabledBinding(true);
            }
            else {
                this.ManufacturerEnabledBinding(false);
                //this.ManufacturerTypeEnabledBinding(false);
            }
        });
        this.ManufacturerId.subscribe((value) => {
            if (value != null) {
                this.ManufacturerTypeEnabledBinding(true);
            }
            else {
                this.ManufacturerTypeEnabledBinding(false);
            }
        });
    }
    //SearcherManufacturer: Bindings.baoSearcher = {
    //    ObjectId: this.ManufacturerId,
    //    ObjectValue: 'Name',
    //    SearchType: 'Manufacturer',
    //    CustomFilter: {
    //        ConfigurationItemTypeId: this.ConfigurationItemTypeId
    //    },
    //    Enabled: this.ManufacturerEnabledBinding,
    //    AutoSearch: true,
    //    AutoComplete: true
    //};
    //SearcherManufacturerType: Bindings.baoSearcher = {
    //    ObjectId: this.ManufacturerTypeId,
    //    ObjectValue: 'Name',
    //    SearchType: 'ManufacturerType',
    //    CustomFilter: {
    //        ManufacturerId: this.ManufacturerId
    //    },
    //    Enabled: this.ManufacturerTypeEnabledBinding,
    //    AutoSearch: true,
    //    AutoComplete: true
    //};
    loaded() {
    }
}
export default PurchaseVendorArtikelTabDialog;